import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputChecbox from "../../helpers/InputCheckbox";

import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboGrupa from "../../helpers/InputComboGrupaE";
import InputPESEL from "../../helpers/InputPESEL";
import InputDate from "../../helpers/InputDate";
import InputPhone from "../../helpers/InputPhone";
import InputEmail from "../../helpers/InputEmail";
import InputCombo from "../../helpers/InputCombo";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputPostCode from "../../helpers/InputPostCode";
import InputNIP from "../../helpers/InputNIP";

import back from "../../back.png";
import InputDateTime from "../../helpers/InputDateTime";

function LayetteShow(props)
{   


    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [tab, setTab] = useState(null);

    const [filterParam, setFilterParam] = useState({   

        id: props.row.id,

        d_imie_nazwisko:  '',
        r_imie_nazwisko:  '', 
        p_grupa_id: '_x_',
        zrealizowane:  '0',

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });

   

    const [row, setRowX] = useState({
       
        id: props.row.id,
        p_grupa_id: props.row.p_grupa_id,
        imie:  props.row.imie,        
        nazwisko: props.row.nazwisko,
        tresc: props.row.tresc,
        zrealizowano: props.row.zrealizowano,
        data_dostarczenia: props.row.data_dostarczenia,
      

    });
    var tmpRow = row;


    var show_zapisz = true;

    if(props.row.zrealizowano==1) show_zapisz=false;

    const [checked1, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked1);
      };

     

      const [checkedR1, setCheckedR1] = useState(false);
      const handleChangeR1 = () => {
            setCheckedR1(!checkedR1);
          };     
     

          const goDeleteOK = (id) => {
       
 
            props.mainView.setProgress(-2);
    
            var req = {
                id:id
            };
    
            fetch( Config.url + '/rest_v1_employessModule,layette_del', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => { 
    
                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                           //props.mainView.showDialog( "Sukces",  "Pozycja została usunięta" , "ok" , null);  
                           props.onBack();
                           //getTab();  
                        }
             } )
             .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
             });
                       
    
             return false;
        }
    
    
    
        const goDelete = (e) => {
    
            var id = e.target.getAttribute("id");
    
            
    
            props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybraną pozycje?", "yesno", (option)=>{
                            ///--------
                            if(option == "yes") goDeleteOK(id);
                            //--------
            } );
        }      


    const valChecker = (fields) => {

        var allValid = true;


        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_employessModule,layette', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        /*
                        setTab(res.result);            


                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.imie  + "  " + item.nazwisko,
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);


                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                        */
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    
    const saveData = () => {


         
        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
    

        props.mainView.setProgress(-2);
        

        var req = row;

        fetch( Config.url + '/rest_v1_employessModule,layette_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        //props.mainView.showDialog( "Sukces",  "Dane zostały zapisane", "ok" , null);         
                        
                        getTab();
                        //Config.removeFromBuffer( Config.cache_kids_search, props.userData );                        
                        props.onBack();
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }
    
    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setRowX( {...tmpRow, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        
        var modX = val.length % 3;
        if(  val.length == 0 || modX == 0 || msg =='combo')
        setTab(null);  

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
         
        setTab(null);    
    }

    const [optionDone, setoptionDone]  = useState([
        {
            v: '0',
            title: 'Nie'
        }, {
            v: '1',
            title: 'Tak'
        }
    ]
    );

    return (

            <div className="view_content">


                    <form className="eForm bg_center">
                        <div className="mobile_form_tab form_tab">
                            <div className="form_tab_title">Wyprawka edycja - {row.imie+' '+row.nazwisko}
 
                            </div>
                                             
                                <div className="form_control">

                                <div className="filter_controll">   
                                    <label>Szczegoły: </label>                             
                                    <InputTextArea  userData={props.userData}   mainView={props.mainView}  value={row.tresc} className='w400 h100'   valChange={valChangeListener} goNext={goNextNew} name="tresc" placeholder={"Treść: "}  req='1'  />
                                </div>

                                <div className="form_split"></div>

                                <div className="filter_controll">   
                                    <label>Zrealizowane: </label>                             
                                    <InputCombo  userData={props.userData}  items={optionDone} mainView={props.mainView}  value={row.zrealizowano}   valChange={valChangeListener} goNext={goNextNew} name="zrealizowano" placeholder={"Archiwalne: "}   />
                                </div>  

                                

                                <div className="filter_controll">   
                                    <label>Data dostarczenia: </label>                             
                                    <InputDateTime  userData={props.userData}  mainView={props.mainView} className='w200'   value={row.data_dostarczenia}   valChange={valChangeListener} goNext={goNextNew} name="data_dostarczenia" placeholder={""}   />
                                </div>

                                </div>

                                    


                        </div>


 

                            <div className="form_split"></div>

                            <div className="form_btn">
                                { show_zapisz && 
                                
                                    <div>
                                        <div className="btn" onClick={saveData}> zapisz </div>
                                        <div className="btn btn_del" onClick={goDelete} id={row.id}> usuń </div>
                                        <div className="btn btn_back" onClick={props.onBack}    > wróć</div>
                                    </div>
                                }
                                
                                { !show_zapisz && 
                                
                                    <div>
                                        <div className="btn btn_back" onClick={props.onBack}    > wróć</div>
                                    </div>
                                }
                            </div>




                    </form>


            </div>
    )

}


export default LayetteShow;


